// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"18":"CustomerStories","34":"companyBusiness","180":"companyWorth","333":"industryTrends","522":"aboutUs","594":"about","799":"JoinUs"}[chunkId] + "." + {"18":"3ec3d9a5","34":"0d2e7e02","180":"62250714","333":"e6fdf4e4","522":"4f33d629","594":"e8473898","799":"71094f55"}[chunkId] + ".js";
};